export default "__VITE_ASSET__DC7WWvkG__"